module.exports = __webpack_public_path__ + "static/datatable-center-do-2623802327ad2abcee6ed08210caf1f3.png";